import { BaseIcon } from './BaseIcon';
import { ReactComponent as svg } from './svgIcons/close.svg';

export const CloseIcon = ({ ...props }) => <BaseIcon svg={svg} {...props} />;
